/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ZipCode/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function ZipCode({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/ExtraFields/Bluefin/Card/ZipCode",
  onChange,
  isInvalid,
  isSubmitting
  
}) {
let paymentCreditCardZipCodeValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'credit_card.zip_code',
})
let paymentCreditCardZipCodeIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payment',
path: 'credit_card.zip_code',
validate: fromValidate.zip,
required: true,
})
let paymentCreditCardZipCodeChangeData = fromData.useDataChange({ viewPath,
context: 'payment',
path: 'credit_card.zip_code',
})
let paymentCreditCardZipCodeIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payment',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="payment.credit_card.zip_code"
 validate="/Data/validate.js zip"
 required={true}
 value={paymentCreditCardZipCodeValueData}
 onChange={paymentCreditCardZipCodeChangeData}
 invalid={!paymentCreditCardZipCodeIsValidData}
 invalidMessage="Please input the ZIP code"
 disabled={paymentCreditCardZipCodeIsSubmittingData}
 marginTop={dtSpaceS}
 marginBottom={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="ZIP code"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="zip"
 placeholder="ZIP code"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}